/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
import { v4 as generateUUID } from 'uuid';
import axiosInstance from './axiosInstance';

export default async function getPublicIpAddr() {
  const ipAddr = await getIpAddressFromTrickleICE();
  return ipAddr;
}

const getIpAddressFromTrickleICE = async () => {
  const peerId = generateUUID();
  const iceServerEndpoint = `${window.location.protocol}//${window.location.host}/api/v1/live/iceServers?peerId=${peerId}`;
  
  try {
    const response = await axiosInstance.get(iceServerEndpoint);
    if (response.data) {
      const iceServerObj = response.data;
      const { iceServers } = iceServerObj;
  
      for (const server of iceServers) {
        let url = null;
        let credential = null;
        let username = null;
  
        if (server.urls) {
          console.log("URL:", server.urls);
          url = server.urls;
        }
        if (server.credential) {
          console.log("Credential:", server.credential);
          credential = server.credential;
        }
        if (server.username) {
          console.log("Username:", server.username);
          username = server.username;
        }
  
        // eslint-disable-next-line no-await-in-loop
        const ipAddress = await trickleICE(url, credential, username);
        if (ipAddress !== null) {
          return ipAddress;
        }
      }
    } else {
      // Handle the case when there is no response.data
      throw new Error("No data received from the server");
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
  return null;
};

const trickleICE = async (url, credential, username) => {
  const isStun = url.includes('stun');
  const isTurn = url.includes('turn');
  if (!isStun && !isTurn) {
    console.log(`No valid TURN or STUN URL found, prefix url with either stun, turn, or turns`);
    return null;
  }
  let iceServers;

  if (isStun) {
    iceServers = [
      {
        urls: url
      }
    ];
  }
  if (isTurn) {
    iceServers = [
      {
        urls: url,
        username,
        credential
      }
    ];
  }
  console.debug(iceServers);
  let pc = null;
  try {
    pc = new RTCPeerConnection({
      iceServers
    });
  } catch (error) {
    console.log(error);
    return null;
  }

  pc.createDataChannel('random-data');
  const offer = await pc.createOffer();
  await pc.setLocalDescription(offer);

  return new Promise((resolve) => {
    const timeoutMs = 10000; // Set a timeout of 10 seconds
    const timeoutId = setTimeout(() => {
      console.debug("Timed out waiting for ICE candidate");
      resolve(null);
      console.log("Closing peer connection");
      pc.close();
    }, timeoutMs);

    pc.onicecandidate = (e) => {
      if (!e.candidate) {
        console.debug("Received null candidate");
        resolve(null);
        clearTimeout(timeoutId);
        console.log("Closing peer connection");
        pc.close();
      } else if (e.candidate.type === "srflx") {
        console.debug("The STUN server is reachable!");
        console.debug(`Public IP Address from trickle ICE: ${e.candidate.address}`);
        resolve(e.candidate.address);
        clearTimeout(timeoutId);
        console.log("Closing peer connection");
        pc.close();
      }
    };
    pc.onicecandidateerror = (e) => {
      console.error(e);
      resolve(null);
      clearTimeout(timeoutId);
      console.log("Closing peer connection");
      pc.close();
    };
  });
};
